var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 75,
    height: 75,
    transform: "translate(754 5787)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_21",
    "data-name": "Mask Group 21",
    transform: "translate(-754 -5787)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_34-Add-image",
    "data-name": "34-Add-image",
    transform: "translate(748.643 5781.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M77.679,64.286H69.643V56.25a2.679,2.679,0,0,0-5.357,0v8.036H56.25a2.679,2.679,0,0,0,0,5.357h8.036v8.036a2.679,2.679,0,0,0,5.357,0V69.643h8.036a2.679,2.679,0,0,0,0-5.357Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M45.536,64.286H13.393a2.679,2.679,0,0,1-2.679-2.679V54.67L21.429,43.955l6.134,6.161a2.679,2.679,0,0,0,3.8,0l14.17-14.2L57.027,47.438a2.69,2.69,0,1,0,3.8-3.8L47.438,30.241a2.679,2.679,0,0,0-3.8,0l-14.17,14.2L23.33,38.277a2.679,2.679,0,0,0-3.8,0l-8.813,8.839V13.393a2.679,2.679,0,0,1,2.679-2.679H61.607a2.679,2.679,0,0,1,2.679,2.679V45.536a2.679,2.679,0,0,0,5.357,0V13.393a8.036,8.036,0,0,0-8.036-8.036H13.393a8.036,8.036,0,0,0-8.036,8.036V61.607a8.036,8.036,0,0,0,8.036,8.036H45.536a2.679,2.679,0,0,0,0-5.357Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M21.429,24.107a8.036,8.036,0,1,0,8.036-8.036,8.036,8.036,0,0,0-8.036,8.036Zm10.714,0a2.679,2.679,0,1,1-2.679-2.679A2.679,2.679,0,0,1,32.143,24.107Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup21);
export default __webpack_public_path__ + "static/media/Mask Group 21.ef4c68f53a987bf92dfd81a120de406f.svg";
export { ForwardRef as ReactComponent };